var _rect, _rect2, _rect3, _rect4, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgHome24Px = function SvgHome24Px(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "home-outline",
    viewBox: "0 0 166 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 166,
    height: 167,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 900,
    transform: "translate(-743 -320)",
    fill: "#F2F3F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -507,
    y: -257,
    width: 1180,
    height: 809,
    rx: 16,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -483,
    y: -233,
    width: 1132,
    height: 761,
    rx: 12,
    fill: "#F2F3F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.833 86.9583L82.9997 24.7083L152.166 86.9583H131.416V142.292H89.9163V100.792H76.083V142.292H34.583V86.9583H13.833ZM117.583 74.4391L82.9997 43.3141L48.4163 74.4391V128.458H62.2497V86.9583H103.75V128.458H117.583V74.4391Z",
    fill: "#76A6FE"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHome24Px);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaG9tZS1vdXRsaW5lIiB2aWV3Qm94PSIwIDAgMTY2IDE2NyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHdpZHRoPSIxNjYiIGhlaWdodD0iMTY3IiBmaWxsPSIjRTVFNUU1Ii8+CiAgICA8cmVjdCB3aWR0aD0iMTQ0MCIgaGVpZ2h0PSI5MDAiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC03NDMgLTMyMCkiIGZpbGw9IiNGMkYzRjgiLz4KICAgIDxyZWN0IHg9Ii01MDciIHk9Ii0yNTciIHdpZHRoPSIxMTgwIiBoZWlnaHQ9IjgwOSIgcng9IjE2IiBmaWxsPSJ3aGl0ZSIvPgogICAgPHJlY3QgeD0iLTQ4MyIgeT0iLTIzMyIgd2lkdGg9IjExMzIiIGhlaWdodD0iNzYxIiByeD0iMTIiIGZpbGw9IiNGMkYzRjgiLz4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIgogICAgICAgICAgZD0iTTEzLjgzMyA4Ni45NTgzTDgyLjk5OTcgMjQuNzA4M0wxNTIuMTY2IDg2Ljk1ODNIMTMxLjQxNlYxNDIuMjkySDg5LjkxNjNWMTAwLjc5Mkg3Ni4wODNWMTQyLjI5MkgzNC41ODNWODYuOTU4M0gxMy44MzNaTTExNy41ODMgNzQuNDM5MUw4Mi45OTk3IDQzLjMxNDFMNDguNDE2MyA3NC40MzkxVjEyOC40NThINjIuMjQ5N1Y4Ni45NTgzSDEwMy43NVYxMjguNDU4SDExNy41ODNWNzQuNDM5MVoiCiAgICAgICAgICBmaWxsPSIjNzZBNkZFIi8+Cjwvc3ZnPgo=";